import styled from 'styled-components';

export const Container = styled.div`
  animation: loading 2s linear infinite;
`;